/* ============================================================
   OraliX Product Page — oralix-product.js
   Cart: fetch /cart/add.js (sections=cart-drawer) → replace the
   drawer's rendered HTML → call cart-drawer's own .open() method
   directly via JS. No <form> submit, no click event on anything
   GemPages/beae.base.min.js recognizes — nothing for it to
   intercept, since a direct method call isn't a DOM event.
   ============================================================ */

/* ── GALLERY THUMBS ─────────────────────────────────────────── */
document.querySelectorAll('.gt').forEach(function(t) {
  t.addEventListener('click', function() {
    document.querySelectorAll('.gt').forEach(function(x) { x.classList.remove('on'); });
    this.classList.add('on');
    var img = document.getElementById('mimg');
    img.style.opacity = '0';
    var src = this.dataset.s;
    setTimeout(function() { img.src = src; img.style.opacity = '1'; }, 180);
  });
});

/* ── SWIPE GALLERY ──────────────────────────────────────────── */
(function() {
  var gmain = document.querySelector('.gmain');
  if (!gmain) return;

  var startX = 0;
  var startY = 0;
  var isDragging = false;

  function getThumbs() {
    return Array.from(document.querySelectorAll('.gt'));
  }

  function getCurrentIndex() {
    var thumbs = getThumbs();
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('on')) return i;
    }
    return 0;
  }

  function goTo(index) {
    var thumbs = getThumbs();
    if (index < 0) index = thumbs.length - 1;
    if (index >= thumbs.length) index = 0;
    thumbs.forEach(function(x) { x.classList.remove('on'); });
    thumbs[index].classList.add('on');
    var img = document.getElementById('mimg');
    img.style.opacity = '0';
    var src = thumbs[index].dataset.s;
    setTimeout(function() { img.src = src; img.style.opacity = '1'; }, 180);
    thumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  gmain.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isDragging = true;
  }, { passive: true });

  gmain.addEventListener('touchend', function(e) {
    if (!isDragging) return;
    var diffX = startX - e.changedTouches[0].clientX;
    var diffY = startY - e.changedTouches[0].clientY;
    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 40) {
      if (diffX > 0) {
        goTo(getCurrentIndex() + 1);
      } else {
        goTo(getCurrentIndex() - 1);
      }
    }
    isDragging = false;
  }, { passive: true });

  gmain.addEventListener('mousedown', function(e) {
    startX = e.clientX;
    isDragging = true;
  });

  gmain.addEventListener('mouseup', function(e) {
    if (!isDragging) return;
    var diffX = startX - e.clientX;
    if (Math.abs(diffX) > 40) {
      if (diffX > 0) {
        goTo(getCurrentIndex() + 1);
      } else {
        goTo(getCurrentIndex() - 1);
      }
    }
    isDragging = false;
  });

  gmain.addEventListener('mouseleave', function() {
    isDragging = false;
  });

  gmain.style.cursor = 'grab';
  gmain.addEventListener('mousedown', function() { gmain.style.cursor = 'grabbing'; });
  gmain.addEventListener('mouseup', function() { gmain.style.cursor = 'grab'; });
})();

/* ── BUNDLE VARIANT SELECTOR ────────────────────────────────── */
function oraliXSelectVariant(el) {
  document.querySelectorAll('.bopt').forEach(function(i) { i.classList.remove('on'); });
  el.classList.add('on');
  var variantId = el.dataset.variantId;
  var price     = el.dataset.price;

  var idInput = document.getElementById('oralix-variant-id');
  if (idInput) idInput.value = variantId;

  var payInput = document.getElementById('oralix-payment-variant-id');
  if (payInput) payInput.value = variantId;

  var priceEl = document.getElementById('oralix-price');
  if (priceEl) priceEl.textContent = price;

  var sbarSel = document.getElementById('sbar-variant-select');
  if (sbarSel) sbarSel.value = variantId;
}

/* ── FAQ ACCORDION ──────────────────────────────────────────── */
function oraliXFaq(el) {
  var item   = el.parentElement;
  var isOpen = item.classList.contains('on');
  document.querySelectorAll('.fitem.on').forEach(function(i) { i.classList.remove('on'); });
  if (!isOpen) item.classList.add('on');
}

/* ── STICKY BAR VARIANT SELECT ──────────────────────────────── */
function oraliXSbarSelect(sel) {
  var variantId    = sel.value;
  var matchingOpt  = document.querySelector('.bopt[data-variant-id="' + variantId + '"]');
  if (matchingOpt) oraliXSelectVariant(matchingOpt);
}

/* ================= NATIVE cart-drawer, opened via direct method call =================
   Proven pattern copied from the working Domme Harness page on the same
   store: fetch /cart/add.js with sections=cart-drawer, manually replace
   the drawer's rendered HTML, then call the drawer's own public .open()
   method directly. */
window.oraliXOpenNativeDrawer = function (cartData) {
  var cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
    cartDrawerEl.open();
    return;
  }
  try {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cartData, bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData, bubbles: true }));
  } catch (e) {}

  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble) bubble.click();
};

window.oraliXAddToCart = function (variantId, btn) {
  if (!variantId) return;
  var origHtml = btn ? btn.innerHTML : '';
  if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: parseInt(variantId),
      quantity: 1,
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    })
  })
    .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
    .then(function (data) {
      if (btn) { btn.disabled = false; btn.innerHTML = origHtml; }

      var html = data.sections && data.sections['cart-drawer'];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newSection = doc.getElementById('shopify-section-cart-drawer');
        var oldSection = document.getElementById('shopify-section-cart-drawer');
        if (newSection && oldSection) oldSection.innerHTML = newSection.innerHTML;
      }

      window.oraliXOpenNativeDrawer(data);
    })
    .catch(function (err) {
      if (btn) { btn.disabled = false; btn.innerHTML = origHtml; }
      console.error('OraliX ATC error', err);
      window.location.href = '/cart';
    });
};

/* ── STICKY BAR ADD TO CART ──────────────────────────────────
   Syncs the selected variant, then runs the exact same
   fetch → open() flow as the main button. */
function oraliXSbarATC() {
  var sel = document.getElementById('sbar-variant-select');
  var variantId = sel ? sel.value : (document.getElementById('oralix-variant-id') ? document.getElementById('oralix-variant-id').value : null);
  window.oraliXAddToCart(variantId, null);
}

/* ── Hook the main Add to Cart button ─────────────────────────
   type="button", not inside a <form>, custom class only —
   nothing here for GemPages to grab. */
(function () {
  var btn = document.getElementById('oralix-atc-btn');
  if (!btn) return;
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    var variantId = document.getElementById('oralix-variant-id').value;
    window.oraliXAddToCart(variantId, btn);
  });
})();